import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class ReservationFilterStateService {

    upcoming: boolean = true;
    isHome: boolean = true;
    completed: boolean = true;
    canceled: boolean = true;
    claimFiled: boolean = true;
    arrivalDate: string = '';
    departureDate: string = '';

    reset(): void {
        this.resetStatusFilters();
        this.resetArrivalDateFilter();
        this.resetDepartureDateFilter();
    }

    resetStatusFilters(): void {
        this.upcoming = true;
        this.isHome = true;
        this.completed = true;
        this.canceled = true;
        this.claimFiled = true;
    }

    resetArrivalDateFilter(): void {
        this.arrivalDate = '';
    }

    resetDepartureDateFilter(): void {
        this.departureDate = '';
    }

    allStatusFiltersEnabled(): boolean {
        return this.upcoming 
            && this.isHome
            && this.completed
            && this.canceled
            && this.claimFiled;
    }

    isStatusFilterActive(): boolean {
        return !this.upcoming
            || !this.isHome
            || !this.completed
            || !this.canceled
            || !this.claimFiled;
    }

    allStatusFiltersDisabled(): boolean {
        return !this.upcoming
            && !this.isHome
            && !this.completed
            && !this.canceled
            && !this.claimFiled
    }

    isUpcomingFilterActive(): boolean {
        return this.upcoming;
    }

    isInHomeFilterActive(): boolean {
        return this.isHome;
    }

    isCompletedFilterActive(): boolean {
        return this.completed;
    }

    isCanceledFilterActive(): boolean {
        return this.canceled;
    }

    isClaimFiledFilterActive(): boolean {
        return this.claimFiled;
    }
}